export const CITY_LIST = [
  "Mumbai",
  "Delhi",
  "Bengaluru",
  "Pune",
  "Hyderabad",
  "Chennai",
  "Kolkata",
  "Ahmedabad",
  // "Jaipur",
  // "Lucknow",
  // "Chandigarh",
  // "Surat",
  // "Noida",
  // "Gurgaon",
  // "Indore",
  // "Nagpur",
  // "Bhopal",
  // "Visakhapatnam",
  // "Vadodara",
  // "Patna",
  // "Ranchi",
  // "Raipur",
  // "Coimbatore",
  // "Thiruvananthapuram",
  // "Kochi",
  // "Kanpur",
  // "Ludhiana",
  // "Amritsar",
  // "Nashik",
  // "Faridabad",
  // "Meerut",
  // "Vijayawada",
  // "Rajkot",
  // "Jodhpur",
  // "Madurai",
  // "Jabalpur",
  // "Gurugram"
];

export const PRICE_OPTIONS = [
  { label: "₹ 5 Lakhs", value: 500000 },
  { label: "₹ 10 Lakhs", value: 1000000 },
  { label: "₹ 15 Lakhs", value: 1500000 },
  { label: "₹ 20 Lakhs", value: 2000000 },
  { label: "₹ 25 Lakhs", value: 2500000 },
  { label: "₹ 30 Lakhs", value: 3000000 },
  { label: "₹ 40 Lakhs", value: 4000000 },
  { label: "₹ 50 Lakhs", value: 5000000 },
  { label: "₹ 60 Lakhs", value: 6000000 },
  { label: "₹ 75 Lakhs", value: 7500000 },
  { label: "₹ 90 Lakhs", value: 9000000 },
  { label: "₹ 1 Crore", value: 10000000 },
  { label: "₹ 1.25 Crore", value: 12500000 },
  { label: "₹ 1.5 Crore", value: 15000000 },
  { label: "₹ 1.75 Crore", value: 17500000 },
  { label: "₹ 2 Crore", value: 20000000 },
  { label: "₹ 3 Crore", value: 30000000 },
  { label: "₹ 4 Crore", value: 40000000 },
  { label: "₹ 5 Crore", value: 50000000 },
  { label: "₹ 10 Crore", value: 100000000 },
  { label: "₹ 20 Crore", value: 200000000 },
  { label: "₹ 30 Crore", value: 300000000 },
  { label: "₹ 50 Crore", value: 500000000 },
  { label: "₹ 75 Crore", value: 750000000 },
];

export const PROPERTY_TYPES = ["commercial", "residential", "buy", "rent"];

export const PROPERTY_TYPE_OPTIONS = [
  "Apartment",
  "Plot",
  "Villa",
  "Independent House",
  "Builder Floor",
  "Penthouse",
  "Office Space",
  "Shop",
  "Land",
  "Office Space IT/SEZ",
  "Showroom",
  "Warehouse",
  "Industrial Plot",
  "Co-Working Space",
  "PG"
];

export const PROJECT_TYPES = [
  {
    label: "Apartment",
    value: "apartment"
  },
  {
    label: "Plot",
    value: "plot"
  },
  {
    label: "Villa",
    value: "villa"
  },
  {
    label: "Builder Floor",
    value: "builder_floor"
  },
  {
    label: "Penthouse",
    value: "penthouse"
  },
  {
    label: "Independent House",
    value: "independent_house"
  }
]

export const CATEGORY_OPTIONS = ["Buy", "Rent"];

export const FURNISHED_TYPES = ["furnished", "semi-furnished", "unfurnished"];

export const BHK_OPTIONS = [
  "Studio",
  "1 RK",
  "1 BHK",
  "1.5 BHK",
  "2 BHK",
  "2.5 BHK",
  "3 BHK",
  "3.5 BHK",
  "4 BHK",
  "5 BHK",
  "6 BHK",
  "6+ BHK",
];

export const FILTER_KEYS = {
  PROPERTY_TYPE: "property_type",
  CATEGORY_TYPE: "category_type",
  BHK_TYPE: "bhk",
  FURNISHED_STATUS: "furnishing_type",
  MIN_PRICE: "min_price",
  MAX_PRICE: "max_price",
  MIN_SQUARE_FT: "min_area",
  MAX_SQUARE_FT: "max_area",
  SEARCH_QUERY: "q",
  CITY: "city",
  COLLECTION: "type",
};

export const PROPERTY_SERVICES = [
  {
    image: "/image/modern_residences.webp",
    title: "Modern Residences",
    description: "Beautifully curated residential properties perfect for individuals and families from apartments to villas",
    link: "/property",
    propertyType: "modern_residencies",
    exploreService: "modern_residencies",
    payloadKey: "building_type",
  },
  {
    image: "/image/smart_spaces.webp",
    title: "Smart Spaces for Business",
    description: "Top commercial spaces for offices, retail, and startups.",
    link: "/property",
    propertyType: "commercial_land",
    exploreService: "smart_spaces",
    payloadKey: "building_type",
  },
  {
    image: "/image/industrial_land.webp",
    title: "Industrial and Investment Land",
    description: "Warehouses, industrial plots, and raw land - perfect for factories, logistics, or future projects.",
    link: "/property",
    propertyType: "industrial_investment_land",
    exploreService: "Industrial_land_investment",
    payloadKey: "property_category_type",
  },
  {
    image: "/image/pgpg.webp",
    title: "PG and co-living",
    description: "Affordable and community-style living for students and working professionals with shared amenities.",
    link: "/property",
    propertyType: "pg_and_co_living",
    exploreService: "pg_coliving",
    payloadKey: "property_type",
  }
];

export const SPECIAL_PROPERTY_TYPES = ["modern_residencies", "pg_and_co_living", "commercial_land", "industrial_investment_land", "owners", "builders", "agents"];

export const PROPERTY_ROOM_OPTIONS = [
  { value: "Pooja Room", label: "Pooja Room" },
  { value: "Servant Room", label: "Servant Room" },
  { value: "Study Room", label: "Study Room" },
  { value: "Extra Room", label: "Extra Room" },
];

export const SHARING_ROOM_OPTIONS = [
  { label: "Private Room", value: "Private Room" },
  { label: "Twin Sharing", value: "Twin Sharing" },
  { label: "Triple Sharing", value: "Triple Sharing" },
  { label: "Quad Sharing", value: "Quad Sharing" }
];

export const PG_RULE_OPTIONS = [
  { label: "1. No Smoking", value: "No Smoking" },
  { label: "2. No Guardian Stay", value: "No Guardian Stay" },
  { label: "3. No Drinking", value: "No Drinking" },
  { label: "4. No Non-Veg", value: "No Non-Veg" },
  { label: "5. Visitor Allow", value: "Visitor Allow" },
  { label: "6. Party", value: "Party" },
  { label: "7. Loud Music", value: "Loud Music" },
  { label: "8. Opposite Gender", value: "Opposite Gender" },
];

export const FOOD_OPTIONS = [
  { label: "Breakfast", value: "Breakfast" },
  { label: "Lunch", value: "Lunch" },
  { label: "Dinner", value: "Dinner" },
];

export const DAY_OPTIONS = [
  { id: "mon", label: "M" },
  { id: "tue", label: "T" },
  { id: "wed", label: "W" },
  { id: "thu", label: "T" },
  { id: "fri", label: "F" },
  { id: "sat", label: "S" },
  { id: "sun", label: "S" },
];

export const NO_IMAGE_PLACEHOLDER = "/image/no_img.png";
export const APP_LOGO = "/image/reelty_Logo2-black.svg";
export const PROJECT_NAME = import.meta.env.VITE_PROJECT_NAME || "REELTY";

export const USER_TYPE = [
  { label: "Agent", value: "AGENT" },
  // { label: "Buyer", value: "BUYER" },
  { label: "Buyer/Owner", value: "OWNER" },
  { label: "Builder", value: "BUILDER" }
]

export const COUNTRY_CODE = [
  {
    value: "+91",
    label: "IN +91",
  },
  {
    value: "+1",
    label: "US +1",
  },
  {
    value: "+44",
    label: "UK +44",
  },
  {
    value: "+61",
    label: "AU +61",
  },
  {
    value: "+81",
    label: "JP +81",
  },
  {
    value: "+49",
    label: "DE +49",
  },
  {
    value: "+971",
    label: "AE +971",
  },
  {
    value: "+7",
    label: "RU +7",
  },
  {
    value: "+27",
    label: "ZA +27",
  },
]

export const WEB_PARAMS = {
  USER_ID: "user_id",
  CITY_NAME: "city_name",
  STATE_NAME: "state_name",
  ACCESS_TOKEN: "access",
  REFRESH_TOKEN: "refresh",
  USER_LOCATION: "userLocation",
  USER_ID_KEY: "_id",
  USER_NAME: "user_name",
  COUNTRY_CODE: "country_code",
  MOBILE_NUMBER: "mobile_number",
  USER_TYPE: "user_type",
  USER_EMAIL: "user_email",
  TOOLTIP_SHOWN: "reelty_tooltip_shown",
};

export const ROUTING_PATH = {
  HOME: "/",
  PROPERTY: "/property",
  SIGNUP: "/signup",
  LOGIN: "/login",
  DASHBOARD: "/dashboard",
  CONTACT: "/contact",
  ADD_NEW_PROPERTY: "/add_new_property",
  EDIT_PROPERTY: "/edit_property",
  ADD_NEW_PROJECT: "/add_new_project",
  EDIT_PROJECT: "/Editproject",
  ADD_NEW_OFFER: "/add_new_offer",
  GET_SCHEDULE: "/get_schedule",
  GET_SCHEDULE_PROPERTY: "/get_schedule_property",
  CONTACT_DETAILS: "/contact_details",
  SHARE_MODAL: "/share_modal",
  PROJECT_DETAIL: "/projectdetail",
  LOGIN1: "/login1",
  SIGNUP1: "/signup1",
  OTP: "/otp",
  ALL_OFFERS: "/all_offers",
  OFFER_DETAIL: "/offerdetail",
  ABOUT_US: "/about_us",
  PRIVACY_POLICY: "/privacy_policy",
  TERMS_AND_CONDITIONS: "/terms_conditions",
  FAQ: "/faq",
  OFFER: "/offer",
  PROPERTY_DETAILS: "/propertydetails",
  DOWNLOAD: "/download",
  DOWNLOAD_SHOTS: "/downloadshots",
  OFFER_PROPERTIES: "/offerproperties",
  SEARCH_RESULTS: "/search",
  AGENT_DETAIL: "/agentdetail",
  PROJECT_LIST: "/project-list",
};

export const UI_MESSAGE = {
  SOMETHING_WENT_WRONG: "Something went wrong. Please try again.",
  OTP_SENT_SUCCESSFULLY: "OTP sent successfully!",
  INVALID_MOBILE_NUMBER: "Please enter a valid mobile number.",
  ENTER_VALID_OTP: "Please enter a valid OTP.",
  USER_NOT_FOUND: "User not found. Please Sign Up First",
  MOBILE_NUMBER_REQUIRED: "Mobile number is required",
  MOBILE_NUMBER_ALREADY_REGISTERED: "Mobile number already verified.",
  MOBILE_NUMBER_MUST_BE_AT_LEAST_10_DIGITS: "Mobile number must be at least 10 digits",
  OTP_RESEND_SUCCESSFULLY: "OTP resent successfully!",
  OTP_VERIFY_SUCCESSFULLY: "OTP verified successfully",
  OTP_VERIFY_FAILED: "OTP verification failed. Please try again.",
  USER_LOGIN_SUCCESSFULLY: "User logged in successfully!",
  USER_LOGIN_FAILED: "User login failed. Please try again.",
  MOBILE_NUMBER_NOT_VERIFIED: "Mobile number is not verified. Please verify OTP first.",
  YOU_NEED_TO_VERIFY_OTP_FIRST: "You need to verify OTP first. Verify now...",
  INVALID_OTP: "Invalid OTP",
  AGREE_TO_TERMS: "Please agree to the terms and conditions",
  YOU_MUST_AGREE_TO_TERMS_AND_CONDITIONS: "You must agree to terms & conditions",
  ERROR_GENERATING_OTP: "Error generating OTP. Please try again.",
  OTP_EXPIRED: "OTP expired. Please try again.",
  NEW_OTP_SENT_SUCCESSFULLY: "New OTP sent successfully!",
  INVALID_SETTINGS: "Invalid settings received.",
  COULD_NOT_FETCH_FREE_VIEW_FREE_POST_LIMITS: "Could not fetch free-view / free-post limits.",
  LINK_COPIED: "Link copied!",
  COPY_FAILED: "Copy failed",
  MARK_FAVORITE: "Marked as favorite!",
  REMOVE_FAVORITE: "Removed from favorite!",
  YOU_MUST_BE_LOGGED_IN_TO_PERFORM_THIS_ACTION: "You must be logged in to perform this action",
  FAILED_TO_SAVE_PROJECT: "Failed to save the Project. Please try again.",
  FAILED_TO_ADD_TO_FAVORITES: "Failed to save to favorites. Please try again.",
  FAILED_TO_REMOVE_FROM_FAVORITES: "Failed to remove from favorites. Please try again.",
  FAILED_TO_REMOVE_PROJECT: "Failed to remove the Project. Please try again.",
  LOGIN: "Login",
  SIGN_UP: "Sign Up",
  SENDING_OTP: "Sending OTP...",
  ALREADY_HAVE_ACCOUNT: "Already have an account?",
  DONT_HAVE_ACCOUNT: "Don't have an account?",
  MOBILE_NUMBER: "Mobile Number",
  LOGOUT_SUCCESSFULLY: "Logout Successfully",
  USER_ALREADY_REGISTERED: "User already registered, Please Login",
  PROFILE_UPDATE_SUCCESS: "Profile updated successfully!",
  PROFILE_UPDATE_FAILED: "Failed to update profile. Please try again.",
  IMAGE_UPLOAD_SUCCESS: "Profile image updated successfully.",
  IMAGE_UPLOAD_FAILED: "Failed to upload image.",
  PROFILE_LOAD_ERROR: "Error loading profile. Please try refreshing.",
  OFFER_CREATE_SUCCESS: "Offer created successfully!",
  OFFER_CREATE_FAILED: "Failed to create offer. Please try again.",
  OFFER_UPDATE_SUCCESS: "Offer updated successfully!",
  OFFER_UPDATE_FAILED: "Failed to update offer. Please try again.",
  OFFER_DELETE_SUCCESS: "Offer deleted successfully!",
  OFFER_DELETE_FAILED: "Failed to delete offer.",
  OFFER_LOGIN_REQUIRED: "You must be logged in to create an offer.",
  OFFER_FILL_ALL_FIELDS: "Please fill all fields and upload an image.",
  PROPERTY_CREATE_SUCCESS: "Property listed successfully.",
  PROPERTY_UPDATE_SUCCESS: "Property updated successfully.",
  PROPERTY_CREATE_FAILED: "Failed to create property. Please try again.",
  PROPERTY_UPDATE_FAILED: "Failed to update property. Please try again.",
  SAVED_SEARCH_CREATED: "Search saved successfully!",
  SAVED_SEARCH_DELETED: "Saved search deleted successfully!",
  SAVED_SEARCH_CREATE_FAILED: "Failed to save search. Please try again.",
  SAVED_SEARCH_DELETE_FAILED: "Failed to delete saved search.",
  SAVED_SEARCH_TITLE_REQUIRED: "Please provide a title for this search.",
}

/**
 * TanStack Query Configuration and Keys
 */
export const QUERY_KEYS = {
  USER_PROFILE: "userProfile",
  PROPERTY_DETAILS: "propertyDetails",
  MY_OFFERS: "myOffers",
  OFFER_DETAILS: "offerDetails",
  OFFER_PROPERTIES: "offerProperties",
  PROPERTIES: "properties",
  AMENITIES: "amenities",
  PROJECT_AMENITIES: "projectAmenities",
  VIDEO_STATUS: "videoStatus",
  CITIES: "cities",
  MY_PROJECTS: "my-projects",
  PROJECT_DETAILS: "projectDetails",
  ALL_PROJECTS: "allProjects",
  ALL_PROJECTS_LIST: "allProjectsList",
  SEARCH_RESULTS: "searchResults",
  MAP_MARKERS: "mapMarkers",
  LEADS: "leads",
  SAVED_SEARCHES: "savedSearches",
  STATIC_PAGE: "staticPage",
  SITE_CONFIG: "siteConfig",
  SUBSCRIPTION_PLANS: "subscriptionPlans",
  PLAN_FEATURES: "planFeatures",
  MY_PLAN_HISTORY: "myPlanHistory",
  MY_PLAN_FAILED: "myPlanFailed",
};

/**
 * CMS static-page / site-config types.
 * Maps to the `type` query param on GET /admin-portal/static-page/type/
 */
export const STATIC_PAGE_TYPE = {
  ABOUT: "about",
  FAQ: "faq",
  PRIVACY: "privacy",
  TERMS: "terms",
  CONTACT_US: "contact_us",
  INSTAGRAM: "instagram",
  TWITTER: "twitter",
  FACEBOOK: "facebook",
  THREADS: "threads",
  LINKEDIN: "linkedin",
  YOUTUBE: "youtube",
  EMAILS: "emails",
  ADDRESS: "address",
  CONTACT_NUMBER: "contact_number",
};

export const QUERY_CONFIG = {
  STALE_TIME: 5 * 60 * 1000, // 5 minutes
  CACHE_TIME: 10 * 60 * 1000, // 10 minutes
  STALE_TIME_1_MINUTE: 1 * 60 * 1000,
  STALE_TIME_2_MINUTES: 2 * 60 * 1000,
  STALE_TIME_3_MINUTES: 3 * 60 * 1000,
  STALE_TIME_4_MINUTES: 4 * 60 * 1000,
  STALE_TIME_5_MINUTES: 5 * 60 * 1000,
  STALE_TIME_10_MINUTES: 10 * 60 * 1000,
  STALE_TIME_15_MINUTES: 15 * 60 * 1000,
  STALE_TIME_20_MINUTES: 20 * 60 * 1000,
  STALE_TIME_30_MINUTES: 30 * 60 * 1000,
  STALE_TIME_INFINITE: Infinity,
};

export const API_ERROR_CODES = {
  SUCCESS_CODE: 200,
  USER_NOT_FOUND: 404,
  USER_NOT_VERIFIED: 401,
  BAD_REQUEST: 400,
  SERVER_ERROR: 500,
  RESOURCE_CREATED: 201,
  SUCCESS_MESSAGE: "success",
  ERROR_MESSAGE: "error",
};

/**
 * Property Card Slider Base Settings
 */
export const PROPERTY_CARD_SLIDER_SETTINGS = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  autoplay: true,
  autoplaySpeed: 2000,
  className: "rounded-t-2xl",
};

/**
 * Toast Notification Configuration
 */
export const TOAST_CONFIG = {
  position: "top-center",
  autoClose: 3000,
  hideProgressBar: false,
  newestOnTop: false,
  closeOnClick: true,
  rtl: false,
  pauseOnFocusLoss: true,
  draggable: true,
  pauseOnHover: true,
  theme: "light",
};

/**
 * Spotlight Slider Settings (3 slides on desktop)
 */
export const SPOTLIGHT_SLIDER_SETTINGS = {
  infinite: true,
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3000,
  arrows: false,
  cssEase: "linear",
  centerMode: false,
  centerPadding: "0px",
  responsive: [
    {
      breakpoint: 1280,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 640,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

/**
 * Offer Type Constants
 * Maps to the offer_type field on the Create Offer API
 */
export const OFFER_TYPE = {
  PROPERTY: "PROPERTY",
  PROJECT: "PROJECT",
  PROJECT_PROPERTY: "PROJECT_PROPERTY",
};

/**
 * Offer Status Constants
 * Lifecycle: PENDING → APPROVED → ACTIVE / QUEUED → EXPIRED
 */
export const OFFER_STATUS = {
  PENDING: "PENDING",
  APPROVED: "APPROVED",
  DISAPPROVED: "DISAPPROVED",
  ACTIVE: "ACTIVE",
  QUEUED: "QUEUED",
  EXPIRED: "EXPIRED",
  INACTIVE: "INACTIVE",
};

// Sidebar Menu Configuration
export const SIDEBAR_MENU_ITEMS = [
  { id: "profile", label: "Profile" },
  { id: "myProperties", label: "My Properties" },
  { id: "myProjects", label: "My Projects", condition: (userType) => userType !== "Owner" },
  { id: "myLeads", label: "My Leads" },
  { id: "myVirtualtour", label: "My Virtual Tour" },
  { id: "mySubscriptions", label: "Subscriptions" },
  { id: "myFavourite", label: "My Favourites" },
  { id: "saveSerches", label: "Saved Searches" },
  { id: "offers", label: "Offers" },
];

// Fallback if API returns nothing
// const fallbackAmenities = [
//   "Smart Home Automation", "Video Doorbell", "Wi-Fi Thermostat",
//   "Voice-Controlled Devices (Alexa, Google Home)", "App-Controlled Lighting", "Solar Rooftop",
//   "Rainwater Harvesting", "Energy-Efficient Appliances", "LEED/IGBC Certified",
//   "Eco-Waste Management", "Gym", "Swimming Pool",
//   "Yoga Deck", "Jogging Track", "Spa & Steam",
//   "Kids' Play Area", "Daycare / Creche", "Senior Citizen Zone",
//   "School Nearby", "Safe Neighborhood", "Pet Park",
//   "Pet Grooming Room", "Nearby Vet Clinics", "Home Office Setup",
//   "Co-working Space", "High-Speed Internet", "Close to Metro"
// ];
